import { environment } from 'environments/environment';
import { EventEmitter, Injectable } from '@angular/core';
import { IChatMessage } from '../models/chat.models';
import * as signalR from '@microsoft/signalr';

@Injectable({
  providedIn: 'root'
})
export class ChatHub {

  public connectionEstablished: EventEmitter<Boolean>;
  public connectionExists: Boolean;
  public connectionId: string;
  public messageReceived: EventEmitter<IChatMessage>;
  private chatConnection: signalR.HubConnection;

  constructor() {
    this.connectionEstablished = new EventEmitter<Boolean>();
    this.connectionExists = false;
    this.messageReceived = new EventEmitter<IChatMessage>();

    // Создаем подключение к современному SignalR Hub
    this.chatConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.api + 'hubChatRoom', {
        transport: signalR.HttpTransportType.ServerSentEvents,
        withCredentials: false // Для CORS с credentials
      })
      .withAutomaticReconnect()
      .build();

    this.registerOnServerEvents();
  }

  public connectToChat(chatId?: string) {
    this.startConnection(chatId);
  }

  public disconnect() {
    this.chatConnection.stop();
  }

  private async startConnection(chatId?: string): Promise<void> {
    if (this.connectionExists) {
      await this.chatConnection.stop();
    }

    try {
      await this.chatConnection.start();
      this.connectionId = this.chatConnection.connectionId || '';

      if (chatId) {
        await this.chatConnection.invoke('joinChat', chatId);
      }

      this.connectionEstablished.emit(true);
      this.connectionExists = true;
    } catch (error) {
      console.error('SignalR connection error:', error);
      this.connectionEstablished.emit(false);
    }
  }

  private registerOnServerEvents(): void {
    // Удаляем старые обработчики и добавляем новые
    this.chatConnection.off('sendMessage');
    this.chatConnection.on('sendMessage', (data: IChatMessage) => {
      this.onMessageReceived(data);
    });
  }

  private onMessageReceived = (data: IChatMessage) => this.messageReceived.emit(data);
}
